<template>
    <div class='sign-panel'>
        <div class='sign-warpper'>
            <img src="../assets/images/index/step1.png" alt="">
            <input v-model="yclink" class="sign-textbox" type="text" placeholder="仅支持原唱歌曲链接，如http://5sing.kugou.com/yc/3312005.html" >
        </div>
        <div class='sign-warpper'>
            <img src="../assets/images/index/step2.png" alt="" >
            <div class="sign-imgbox">
                <el-upload
                    class="upload-img"
                    ref="upload"
                    action="http://5sing.kugou.com/subject/api/upload/image"
                    list-type="picture-card"
                    accept="image/*"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :on-success="handleSuccess">
                    <i class="el-icon-plus" type="primary"></i>
                    <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                </el-upload>
                <!-- <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog> -->
            </div>
            
            <div class='sign-imgtip'>
                <p>请选择个人写真</p>
                <p>尺寸不小于800*450、大小不超过2M、格式为png或jpg的图片</p>
            </div>
        </div>
        <div class='sign-warpper'>
            <img src="../assets/images/index/step3.png" alt="">
            <input v-model="mvlink" class="sign-textbox" type="text" placeholder="仅支持视频链接，如http://5sing.kugou.com/39860242/Video/372.html">
        </div>
        <a class="sign-button" href="javascript:;" v-on:click="validYC">我要参赛</a>
    </div>
</template>
<script>
const ycRule =  /^http:\/\/5sing.kugou.com\/(yc)+\/\d+.html$/;
const mvRule =  /^http:\/\/5sing.kugou.com\/\d+\/Video\/(\d+).html$/;
let mv_id;
export default {
    name: "sign",
    data() {
        return {
            signConfig: this.$winConfig.signConfig,
            columnIndex: 0,
            yclink: "",
            mvlink: "",
            type: 'yc',
            dialogImageUrl: "",
            dialogVisible: false,
            isHttp: false
        };
    },
    mounted:function(){
        var _this = this;
        eventbus.$on("signMsg", function (res) {
            if(!_this.isHttp && res.type == 'signSuccess-'+_this.type){
                _this.isHttp = true;
                _this.signYC();
            }
        });  
    },
    methods: {
        beforeAvatarUpload(file) {
            const imgRule =  /^image\/(jpg|jpeg|png)$/;
            const isJPG = imgRule.test(file.type);
            const isLt5M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$tipsBox.error({
                    message: '请上传格式为png或jpg的图片!'
                });
            
            }else if (!isLt5M) {
                this.$tipsBox.error({
                    message: '请上传大小不超过2M的图片'
                });
            }
            return isJPG && isLt5M;
        },
        handleRemove(file, fileList) {
            this.dialogImageUrl = '';
            document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'inline-block';
        },
        handleChange(file, fileList){
            let _this = this;
            let nImg = new Image();
            nImg.src = file.url;
            nImg.onload = function() {
                if(nImg.width < 800 || nImg.height < 450){
                    _this.$refs.upload.abort();
                    _this.$refs.upload.clearFiles();
                    _this.$tipsBox.error({
                        message: '请上传尺寸不小于800*450的图片'
                    });
                }
    　　　　}
        },
        handleSuccess(file){
            if(file.code == 0){
                document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'none';
                this.dialogImageUrl = file.data.url;
            }else{
                this.$refs.upload.clearFiles();
                this.$tipsBox.error({
                    message: file.message
                });
            }
        },

        /**
         * 原创报名参赛。
         *
         * @param {string} id     加密栏目id。
         * @param {string} url    原创报名歌曲地址。
         * @param {number} isApp  是否使用app报名，其中1表示使用手机端进行报名；不传递该参数表示使用PC端进行报名。默认不传该参数。
         * @param {string} sign   如果使用了app进行报名（即isApp设置为1）时必须传递该参数，否则报名失败。
         * @param {number} type   报名类型，其中1表示歌曲报名；2表示歌单报名。默认歌曲报名。
         *
         */
        validYC:function(){
            this.type = 'yc';
            if(!this.$winConfig.isLogin){
                this.$tipsBox.error({
                    message: "请先登录",
                    reload: "http://5sing.kugou.com/login/"
                });
            }else{
                if (this.yclink == "") {
                    this.$tipsBox.error({
                        message: "请填写歌曲地址！"
                    });
                } else if (ycRule.test(this.yclink)) {
                    if(this.mvlink != '' && !mvRule.test(this.mvlink)){
                        this.$tipsBox.error({
                            message: "请填写正确的视频地址！"
                        });
                        return;
                    }
                    this.$signMsg.show({type: this.type});
                } else {
                    this.$tipsBox.error({
                        message: "请使用原创歌曲报名参赛！"
                    });
                }
            }
        },
        signYC: function(event) {
            let _this = this;
            if(this.mvlink != ''){
                mv_id = this.mvlink.replace(/^http:\/\/5sing.kugou.com\/\d+\/Video\/(\d+).html$/g,'$1');
                let formValidMv = {
                    sid: this.signConfig[1].id,
                    signup_type: 8,
                    music_address: this.yclink,
                    mv_id: mv_id,
                    cover: this.dialogImageUrl
                };
                this.$server.sign(formValidMv).then(function(res){
                    res = res.data;
                    if (res.code == 10010) {
                        _this.$tipsBox.error({
                            message: "请先登录",
                            reload: "http://5sing.kugou.com/login/"
                        });
                    } else if (12311 === res.status) {
                        _this.$tipsBox.error({
                            message: "该视频作品已报名成功，请不要重复提交。"
                        });
                    } else if (12305 === res.status) {
                        _this.$tipsBox.error({
                            message: "请使用自己的视频作品报名！"
                        });
                    } else if (0 === res.status) {
                        //歌曲报名
                        let formData = {
                            sid: _this.signConfig[_this.columnIndex].id,
                            signup_type: 1,
                            music_address: _this.yclink,
                            mv_id: mv_id,
                            cover: _this.dialogImageUrl
                        };
                        _this.signHttp(formData);
                        
                    } else {
                        _this.$tipsBox.error({
                            message: res.message
                        });
                    }
                    _this.isHttp = false;
                }).catch(function(){
                    _this.isHttp = false;
                    _this.$tipsBox.error({
                        message: "服务器开小差，请稍后再试..."
                    });
                });
            }else if(this.yclink != ''){
                //歌曲报名
                let formData = {
                    sid: this.signConfig[_this.columnIndex].id,
                    signup_type: 1,
                    music_address: this.yclink,
                    mv_id: '',
                    cover: this.dialogImageUrl
                };
                this.signHttp(formData);
            }
        },
        /**
         * 翻唱报名参赛。
         *
         * @param {string} id     加密栏目id。
         * @param {string} url    原创报名歌曲地址。
         * @param {number} isApp  是否使用app报名，其中1表示使用手机端进行报名；不传递该参数表示使用PC端进行报名。默认不传该参数。
         * @param {string} sign   如果使用了app进行报名（即isApp设置为1）时必须传递该参数，否则报名失败。
         * @param {number} type   报名类型，其中1表示歌曲报名；2表示歌单报名。默认歌曲报名。
         *
         */
        signFC: function(event) {
            let fcRule = /^http:\/\/5sing.kugou.com\/(fc)+\/\d+.html$/;
            if (this.yclink == "") {
                this.$tipsBox.error({
                message: "请填写歌曲地址！"
                });
            } else if (ycRule.test(this.fclink)) {
                let formData = {
                sid: this.signConfig[this.columnIndex].id,
                signup_type: 2,
                music_address: this.fclink
                };
                this.signHttp(formData);
            } else {
                this.$tipsBox.error({
                message: "请使用翻唱歌曲报名参赛！"
                });
            }
        },
        /**
         * 报名请求。
         * @param {object} formData         请求参数
         * @param {string} ADD_WORK_URL     请求地址
         */
        signHttp: function(formData) {
            var _this = this;
            _this.$server.sign(formData).then(function(res){
                res = res.data;
                if (res.code == 10010) {
                    _this.$tipsBox.error({
                        message: "请先登录",
                        reload: "http://5sing.kugou.com/login/"
                    });
                } else if (12311 === res.status) {
                    _this.$tipsBox.error({
                        message: "该歌曲已报名成功，请不要重复提交。"
                    });
                } else if (12303 === res.status) {
                    _this.$tipsBox.error({
                        message: "请确认歌曲状态正常再报名参赛！"
                    });
                } else if (12305 === res.status) {
                    _this.$tipsBox.error({
                        message: "请使用自己的原创作品报名！"
                    });
                } else if (0 === res.status) {
                    _this.$tipsBox.confirm({
                        message: "恭喜您，报名成功！",
                        yes: '查看我的作品',
                        no: '再逛逛',
                        sure: function(){
                            _this.$router.replace({
                                name: 'indexWork',
                                path: '/work',
                                params: {
                                    order: 1,
                                    scroll: 1000,
                                }
                            })
                        }
                    });
                    //mv报名
                    if(_this.mvlink != ''){
                        let formDataMv = {
                            sid: _this.signConfig[1].id,
                            signup_type: 7,
                            mv_id: mv_id,
                        };
                        _this.$server.sign(formDataMv).then(function(){});
                    }
                    //清空报名数据
                    _this.yclink = '';
                    _this.$refs.upload.clearFiles();
                    document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'inline-block';
                    _this.mvlink = '';
                } else {
                    _this.$tipsBox.error({
                        message: res.message
                    });
                }
                _this.isHttp = false;
            }).catch(function(res){
                _this.isHttp = false;
                _this.$tipsBox.error({
                    message: "服务器开小差，请稍后再试..."
                });
            });
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.sign-warpper {
  padding: 15px 0;
  img {
    margin-right: 10px;
    vertical-align: top;
  }
  .sign-textbox {
    width: 800px;
    height: 36px;
    padding: 0 10px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    background-color: #6745b3;
  }
  .sign-imgbox {
    display: inline-block;
    vertical-align: bottom;
    overflow: hidden;
    .upload-img{
        position: relative;
        width: 195px;
        height: 148px;
        .el-upload-list__item-preview{
            display: none;
        }
        .el-upload-list__item-delete{
            margin-left: 0;
        }
        .el-upload--picture-card{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #6745b3;
            border: 1px solid #fff;
            i{
                color: #fff;
            }  
        }
        .el-upload-list--picture-card{
            .el-upload-list__item{
                width: 100%;
                height: 100%;
                margin: 0;
            }
        }
    }
  }
  .sign-imgtip {
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    vertical-align: bottom;
  }
}
.sign-button {
  display: block;
  width: 100px;
  padding: 8px 0;
  margin: 10px auto;
  color: #542eab;
  background-color: #fff;
  border-radius: 4px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/sign-tab.vue